<template>
<div>
        <div class="page-header">
          <div class="container-fluid">
            <h2 class="h5 no-margin-bottom">Genel Tanımlamalar</h2>
          </div>
        </div>

  <section class="no-padding-top no-padding-bottom">
  <div class="container-fluid">
  <div class="row">
              <div class="col-lg-6 col-12">
                <div class="block">
                    <div class="block-body">
                      <form @submit.prevent="sendNewPost">
                        <div class="form-group">
                          <label class="form-control-label">Kodu</label>
                          <input name="title" type="text" class="form-control" v-model="newPost.kodu" />
                        </div>
                        <div class="form-group">       
                          <label class="form-control-label">Alias</label>
                          <input name="title" type="text" class="form-control" v-model="newPost.alias" />  
                        </div>
                        <div class="form-group">       
                          <input type="submit" :disabled="inProgress" :value="mode" class="btn btn-primary w-100">
                        </div>
                      </form>
                    </div>
                  </div>
              </div>
              <div class="col-lg-6">
                <div class="block margin-bottom-sm">
                  <div class="table-responsive"> 
                    <table class="table table-striped table-sm">
                      <thead>
                        <tr>
                          
                          <th>Kodu</th>
                          <th>Alias</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="post in posts" :key="post.id">
                          
                          <td>{{post.kodu}}</td>
                          <td>{{post.alias}}</td>
                          <td><button @click="aktar(post.kodu,post.alias,post.id)" class="btn btn-dark btn-sm">Düzenle</button></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>       
            </div>
            <div class="row">
              <div class="col-12">
                <div class="footer__block block no-margin-bottom">
                  <div class="container-fluid text-center">
                    Sistem Hatası : {{ errors.length }}  {{ errors.message }}        
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
</template>

<script>
  export default {

    async created() {
      await this.getPostsAsync(this.newPost.table);
    },
    data() {
      return {
        progres : {
          mesaj:'Bekleyiniz',
          inprogres:false
        } ,
        posts: [],
        errors: [],        
        kodu : '',
        alias : '',
        mode:'Ekle',
        idsi:'', // güncelleme için satır id
        newPost: {
          kodu: '',
          alias:'',
          firma : this.$request.ayar().firmaid,
          table : this.$route.params.table,
        }        
      };
    },
    methods: {
        yetki: function(){
          if (this.$helper.sayfayetki(319839)){
             this.getPostsAsync(this.newPost.table)
          }
          else{
                alert('Bu alanı kullanım yetkiniz yok')
                this.$router.go(-1)
          }
        },
        aktar(kodu,alias,id){
            this.idsi = id;
            this.newPost.kodu = kodu;
            this.newPost.alias = alias;
            this.mode = "Düzenle ( Yeni kayıt için sayfayı yenileyin )"
        },
        getPostsAsync(tables){
          this.$request.get("/define/"+this.newPost.firma+"/"+tables)
            .then(res => {
              this.posts = res.results;
            })
        },
     // async getPostsAsync(tables) {
   //     try {
   //       const response = await this.$axios.get("/define/"+this.newPost.firma+"/"+tables);
   //       this.posts = response.data.results;
   //     } catch (error) {
  //        this.errors.push(error);
  //      }
  //    },
      sendNewPost() {
        if (this.newPost.kodu && this.newPost.alias){
          this.progres.inProgress = true
          if (this.mode==="Ekle")
          {
            this.$request.post("define/",this.newPost )
            .then( res =>{
              console.log(res)
             this.$swal("Kayıt Ekleme Başarılı")
             this.getPostsAsync(this.newPost.table)
            }
          )
        .catch(err => this.$swal(err))
        }
        else{
          let data = Object.assign(this.newPost,{id:this.idsi})
            this.$request.post("defineUpdate/",data )
            .then( res =>{
             this.$swal("Düzenleme Başarılı")
             this.getPostsAsync(this.newPost.table)

            }
          )
        .catch(err => this.$swal(err))          
        }
        this.progres.inProgress = false;
        }
        else{
          this.$swal("Girdileri Kontrol Et")
        }
      },     
    },
    watch : {
        "$route.params.table":function(val) {
          this.getPostsAsync(val)
        },
      },    
  };
</script>


// WEBPACK FOOTER //
// src/views/defines.vue